import { useEffect } from 'react';
import { Box, Stack, Grid, Button, Typography, styled } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Field } from 'react-final-form';

import MultiSelect from '@components/MultiSelect';

import { paymentOptionsMethodMatrixActions } from '../../store/payment-options-method-matrix';
import { getLOBs, selectLOBList } from '../../store/payment-options-merchants';
import {
  getPaymentMethods,
  selectMethodList,
} from '../../store/payment-options-methods';
import {
  getPlatforms,
  selectPlatforms,
} from '../../store/payment-options-platforms';
import {
  getCurrencies,
  selectCurrencies,
} from '../../store/payment-options-currencies';
import {
  getGateways,
  selectPaymentGateways,
} from '../../store/payment-options-gateways';

const MethodMatrixFiltersWrapper = styled(Stack)`
  gap: 16px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  box-shadow: 0 4px ${({ theme }) => theme.palette.grey[300]};
  border-radius: 4px;
  padding: 16px;
`;
const Header = styled(Stack)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Footer = styled(Box)`
  position: sticky;
  bottom: 0;
  margin-top: 16px;
  z-index: 9;
`;

export default function MethodMatrixFilters() {
  const dispatch = useDispatch();

  const lobList = useSelector(selectLOBList);
  const platformList = useSelector(selectPlatforms);
  const currencyList = useSelector(selectCurrencies);
  const paymentMethodList = useSelector(selectMethodList);
  const gatewayList = useSelector(selectPaymentGateways);

  // APIs- Filter data
  useEffect(() => {
    dispatch(getLOBs());
    dispatch(getPaymentMethods());
    dispatch(getPlatforms());
    dispatch(getCurrencies());
    dispatch(getGateways());
  }, [dispatch]);

  const onSubmit = (values) => {
    dispatch(paymentOptionsMethodMatrixActions.setFilters(values));
  };

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, form }) => (
        <MethodMatrixFiltersWrapper>
          <Header>
            <Typography variant="button">Filters</Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                form.reset();
              }}>
              Reset
            </Button>
          </Header>
          <form
            onSubmit={handleSubmit}
            noValidate>
            <Grid
              container
              spacing={2}>
              <Grid
                item
                xs={12}>
                <Field name="filteredLOB">
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value, onChange }}
                      multiple
                      items={lobList}
                      label="Select LOB"
                      optionDisplayKey="lobName"
                      customOptionLabel={({ lobName }) => lobName}
                      isOptionEqualToValue={(option, val) =>
                        option.lobCode === val.lobCode
                      }
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={12}>
                <Field name="filteredPaymentMethod">
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value, onChange }}
                      multiple
                      items={paymentMethodList}
                      label="Select Payment Method"
                      optionDisplayKey="methodName"
                      customOptionLabel={({ methodName }) => methodName}
                      isOptionEqualToValue={(option, val) =>
                        option.methodCode === val.methodCode
                      }
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={12}>
                <Field name="filteredPlatform">
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value, onChange }}
                      multiple
                      items={platformList}
                      label="Select Platform"
                      isOptionEqualToValue={(option, val) =>
                        option.code === val.code
                      }
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={12}>
                <Field name="filteredCurrency">
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value, onChange }}
                      multiple
                      items={currencyList}
                      label="Select Currency"
                      isOptionEqualToValue={(option, val) =>
                        option.code === val.code
                      }
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={12}>
                <Field name="filteredGateway">
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value, onChange }}
                      multiple
                      items={gatewayList}
                      label="Select Gateway"
                      isOptionEqualToValue={(option, val) =>
                        option.code === val.code
                      }
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={12}>
                <Field name="filteredStatus">
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value, onChange }}
                      multiple
                      items={[
                        {
                          id: 1,
                          code: '1',
                          name: 'Active',
                        },
                        {
                          id: 0,
                          code: '0',
                          name: 'In-Active',
                        },
                      ]}
                      label="Select Status"
                      isOptionEqualToValue={(option, val) =>
                        option.code === val.code
                      }
                    />
                  )}
                </Field>
              </Grid>
            </Grid>
            <Footer>
              <Button
                variant="contained"
                fullWidth
                type="submit">
                Search
              </Button>
            </Footer>
          </form>
        </MethodMatrixFiltersWrapper>
      )}
    />
  );
}
